import { AppState } from '../../store'

export const getPageData = () => (state: AppState) => state.pageData
